import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FnUiIconModule} from "../../../../shared/fn-ui-icons/fn-ui-icon/fn-ui-icon.module";
import {MatButton} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {UserQuickActionButton} from "../../../../messages-center/models/user-quick-action-button.model";
import {QuickActions} from "../../../../messages-center/models/enums/quick-actions.enum";

@Component({
  selector: 'app-quick-action-button',
  standalone: true,
  imports: [
    FnUiIconModule,
    MatButton,
    TranslateModule
  ],
  templateUrl: './quick-action-button.component.html',
  styleUrl: './quick-action-button.component.scss'
})
export class QuickActionButtonComponent {
  @Input() userQuickActionButton: UserQuickActionButton;
  @Input() buttonDisabled: boolean;
  @Input() isLoading: boolean;

  @Output() buttonClick : EventEmitter<QuickActions> = new EventEmitter<QuickActions>();

  onClick(){
    this.buttonClick.emit(this.userQuickActionButton.quickAction)
  }
}
